import { render, staticRenderFns } from "./TabUserDashboard.vue?vue&type=template&id=030799ac&"
import script from "./TabUserDashboard.vue?vue&type=script&lang=js&"
export * from "./TabUserDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports